import { Theme } from '@mui/material';

/**
 * Configuration for the PowerProfileChart component
 */

/**
 * Chart margins configuration
 */
export const chartMargins = {
  top: 10,
  right: 40,
  left: 20,
  bottom: 0,
} as const;

/**
 * Chart styling configuration
 */
export const chartStyles = {
  cursor: {
    default: 'default',
    grab: 'grab',
    grabbing: 'grabbing',
  },
  userSelect: 'none',
} as const;

/**
 * Gradient configuration for the chart area
 */
export const gradientConfig = (theme: Theme) => ({
  id: 'powerGradient',
  stops: [
    {
      offset: '4.11%',
      stopColor: theme.palette.success.light,
    },
    {
      offset: '100.77%',
      stopColor: theme.palette.success.background,
    },
  ],
});

/**
 * Cartesian grid configuration
 */
export const gridConfig = {
  strokeDasharray: '5 5',
  strokeKey: 'grey.300',
  horizontal: true,
  vertical: true,
} as const;

/**
 * X-axis configuration
 */
export const xAxisConfig = {
  dataKey: 'timestamp',
  tick: {
    fontSize: 16,
  },
  tickLine: true,
  axisLine: false,
  interval: 95,
} as const;

/**
 * Y-axis configuration
 */
export const yAxisConfig = {
  tick: {
    fontSize: 16,
  },
  tickLine: true,
  axisLine: true,
  tickFormatter: (value: number) => value.toFixed(0),
} as const;

/**
 * Area configuration
 */
export const areaConfig = {
  type: 'linear',
  dataKey: 'power',
  fillOpacity: 0.4,
  strokeWidth: 2,
  dot: false,
  activeDot: {
    r: 6,
    strokeWidth: 2,
  },
} as const;

/**
 * Responsive container configuration
 */
export const responsiveContainerConfig = {
  width: '100%',
} as const;

/**
 * Helper function to get gradient stops with theme colors
 */
export const getGradientStops = (theme: Theme) => {
  return gradientConfig(theme).stops.map((stop) => ({
    offset: stop.offset,
    stopColor: stop.stopColor,
  }));
};

/**
 * Helper function to get grid stroke color from theme
 */
export const getGridStrokeColor = (theme: Theme) => {
  return theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300];
};
